import BaseExternalRequestMixin from "@/modules/core/externalrequest/public/BaseExternalRequestMixin";
import RequestForm from "./CreditAssignmentExternalRequestForm";
import service from "./CreditAssignmentExternalRequestService";

export default {
  mixins: [BaseExternalRequestMixin],

  components: {
    RequestForm
  },

  props: {
    styleClass: {
      default: "bg-credit-assignment"
    }
  },

  computed: {
    title() {
      return this.$t("menu.creditAssignmentExternalRequest");
    }
  },

  methods: {
    getService() {
      return service;
    }
  }
};
